// extracted by mini-css-extract-plugin
module.exports = {"reverse-first":"CardGrid_reverse-first__kQpfl","cardGrid":"CardGrid_cardGrid__wsTja","reverse":"CardGrid_reverse__FAVWs"};